<template>
  <div>
    <div class="row">
      <div class="flex col-6">
        <h2 class="l-header-2 rates">Rates</h2>
        <customTooltip :config="{ placement: 'right' }" v-if="job.contract_signed">
          <div
            slot-scope="{ isOpen, open, close }"
            @mouseover="open"
            @mouseleave="close"
            class="tooltip"
          >
            <i class="fa fa-file rates-icon"
               data-trigger
            />
            <div
              v-show="isOpen"
              data-popper
              class="custom-tooltip"
            >
              <div
                x-arrow
                class="border-black"
              />
              Pre-move agreement signed
            </div>
          </div>
        </customTooltip>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-change"
                v-if="!editableFields && isActive && $_can('jobs.change')"
                :disabled="!hasAccess"
                @click="setEditableFields"
        >
          <i class="fa fa-pencil mr-1" aria-hidden="true" />Change
        </button>
      </div>
    </div>

    <div class="row my-3 rates-wrapper">
      <div class="col-12 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2 mb-3 mb-xl-0 mb-lg-0 mb-md-0">
        <div class="select-wrap">
          <label>Move date</label>
          <flat-pickr v-model="job.move_date_new"
                      :config="config"
                      :disabled="isFlatRate"
                      class="form-control"
                      style="visibility: hidden"
                      placeholder="Select date"
                      red="flatPickr"
                      @on-close="closedDatePickr"
                      @on-change="updateOffers"
                      data-input
          />
          <input v-if="!job.move_date_new"
                 v-model="job.move_date"
                 placeholder="Select date"
                 :disabled="!editableFields || isFlatRate"
                 class="form-control flatpickr-input-sec pointer select-date-input"
                 data-toggle
          />
          <input v-else
                 v-model="job.move_date_new"
                 placeholder="Select date"
                 :disabled="!editableFields || isFlatRate"
                 class="form-control flatpickr-input-sec pointer select-date-input"
                 data-toggle
          />
        </div>
        <error-field :errors="errors" field="move_date" />
      </div>
      <div class="col-12 col-lg-4 col-md-4 col-xl-4 px-lg-2 px-md-2 px-xl-2">
        <div class="select-wrap">
          <label>Arrival window</label>
          <simple-select v-model="job.arrival_window_id"
                         :options="arrivalWindows"
                         :disabled="!editableFields || isFlatRate"
                         @input="updateOffers"
                         label="label"
                         placeholder="Select Arrival Window"
          />
        </div>
        <error-field :errors="errors" field="arrival_window_id" />
      </div>
      <div class="col-3 col-lg-1 col-md-1 col-xl-1 pr-0 pl-lg-2 pl-md-2 pl-xl-2 price-info">
        <label>Price</label>
        <p class="m-0" v-if="!job.is_flat_rate">{{ job.price_per_hour }}</p>
        <p class="m-0" v-else>{{ job.price }}</p>
        <error-field :errors="errors" field="price" />
      </div>
      <div class="col-2 col-lg-1 col-md-1 col-xl-1 pr-0 pl-lg-2 pl-md-2 pl-xl-2 price-info">
        <label />
        <customTooltip :config="{ placement: 'right' }">
          <div
            slot-scope="{ isOpen, open, close }"
            @mouseover="open"
            @mouseleave="close"
            style="padding: 0px 5px 0px 5px"
          >
            <i class="fa fa-home"
               :class="job.is_small === 1 ? 'icon-color': 'icon-color2'"
               data-trigger
            />
            <div
              v-show="isOpen"
              data-popper
              class="custom-tooltip"
            >
              <div
                x-arrow
                class="border-black"
              />
              {{ isSmallJob }}
            </div>
          </div>
        </customTooltip>
      </div>
      <div class="col-4 col-lg-1 col-md-1 col-xl-1 pr-0 pl-lg-2 pl-md-2 pl-xl-2 price-info">
        <label>Transaction fee</label>
        <p class="m-0">{{ job.company.charge_fee || 0 }}%</p>
      </div>
      <div class="col-3 col-lg-1 col-md-1 col-xl-1 pr-0 pl-lg-2 pl-md-2 pl-xl-2 pl-2 price-info" v-if="job.company.cash_discount_value > 0 && !isFlatRate">
        <label>Cash Discount</label>
        <p class="m-0">{{ job.cash_discount_value }} {{ job.cash_discount_unit }}</p>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-12 col-lg-4 col-md-4 col-xl-4 pr-lg-2 pr-md-2 pr-xl-2 mb-3 mb-xl-0 mb-lg-0 mb-md-0">
        <div class="select-wrap">
          <label>Move Size</label>
          <simple-select v-model="job.move_size_id"
                         :options="moveSizes"
                         :disabled="!editableFields || isFlatRate"
                         @input="updateOffers"
                         placeholder="Select Move Size"
          />
        </div>
        <error-field :errors="errors" field="move_size_id" />
      </div>
      <div class="col-6 col-lg-4 col-md-4 col-xl-4 px-lg-2 px-md-2 px-xl-2">
        <div class="select-wrap">
          <label>Movers</label>
          <simple-select v-model="job.movers"
                         :options="numberOfMovers"
                         :disabled="!editableFields"
                         @input="updateOffers"
                         placeholder="Select Movers"
          />
        </div>
        <error-field :errors="errors" field="movers" />
      </div>
      <div class="col-6 col-lg-4 col-md-4 col-xl-4 pl-lg-2 pl-0 pl-md-2 pl-xl-2">
        <div class="select-wrap">
          <label>Trucks</label>
          <input v-model="job.trucks"
                 type="text"
                 class="form-control"
                 :disabled="!editableFields"
                 @change="updateOffers"
          />
        </div>
        <error-field v-if="errors" :errors="errors" field="trucks" />
        <error-field v-if="errors" :errors="errors" field="truck_number" />
      </div>
    </div>

    <!--Offers-->
    <template v-if="changed && !job.is_flat_rate">
      <offer :data="job"
             :book-offer-prop="bookOffer"
             :button-disabled="buttonDisabled"
             :loading-book-button="loadingBookButton"
             :booking-phone="job.company.booking_phone"
             @setOfferError="setOfferError"
             @offer-offered="offerOffered = true"
             ref="offerRef"
             v-if="editableFields"
             class="my-1"
      />
    </template>
    <span v-if="job.company.booking_send_offers">
      <div v-if="changed && editableFields && offerOffered" class="flex align-items-end justify-content-end">
        <div class="flex flex-column align-items-center justify-content-center">
          <button class="btn btn-primary" @click="sendJobRescheduleEmail()">
            Send reschedule link to customer
          </button>
          <div>
            <customTooltip :config="{ placement: 'top' }">
              <div
                slot-scope="{ isOpen, open, close }"
                @mouseover="open"
                @mouseleave="close"
                style="padding: 0px 5px 0px 5px"
              >
                <p v-if="job.offers_sent_diff" class="lead-sent-offer-diff" data-trigger>
                  Sent {{ job.offers_sent_diff }}
                </p>
                <div
                  v-show="isOpen"
                  data-popper
                  class="custom-tooltip"
                >
                  <div
                    v-if="job.offers_sent"
                    x-arrow
                    class="border-black"
                    style="color: black;"
                  />
                  {{ job.offers_sent }}
                </div>
              </div>
            </customTooltip></div>
        </div></div>
    </span>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import flatPickr from 'vue-flatpickr-component';
import customTooltip from '../CustomTooltip';
import Offer from '../Offer';
import Errors from '../../classes/Errors';

export default {
  components: {
    flatPickr,
    customTooltip,
    Offer,
  },
  props: {
    arrivalWindows: {
      type: Array,
      default: () => [],
    },
    job: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {},
    },
    editedField: {
      type: Boolean,
      default: false,
    },
    editableFields: {
      type: Boolean,
      default: false,
    },
    moveSizes: {
      type: Array,
      default: () => [],
    },
    numberOfMovers: {
      type: Array,
      default: () => [],
    },
    isSmallJob: {
      type: String,
      default: '',
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    changed: false,
    buttonDisabled: false,
    loadingBookButton: false,
    offerOffered: false,
    errors: new Errors(),
  }),
  computed: {
    isFlatRate() {
      return this.job.is_flat_rate === 1;
    },
    isActive() {
      return (
        this.job.status &&
        this.job.status.name !== 'Canceled' &&
        this.job.status.name !== 'Completed'
      );
    },
  },
  methods: {
    setEditableFields() {
      this.$emit('editableFields');
      this.changed = true;
      this.callGetOffers();
    },
    bookOffer(job) {
      this.buttonDisabled = true;
      this.loadingBookButton = true;
      const changedJob = { ...job };
      this.$delete(changedJob, 'double_drive_time');
      this.$delete(changedJob, 'job_time');
      this.$delete(changedJob, 'total_hours');
      axios
        .put(`jobs/${this.$route.params.id}`, changedJob)
        .then(res => {
          if (res.data.error) {
            toastr.warning('Some addresses are not covered by the company', '', { timeOut: 0 });
            this.loadingBookButton = false;
            this.buttonDisabled = false;
          } else {
            toastr.success('Job successfully updated');
            this.$emit('getJob');
            this.loadingBookButton = false;
            this.buttonDisabled = false;
            this.editableFields = false;
          }
        })
        .catch(err => {
          Object.keys(err.response.data.error).forEach(key => {
            toastr.error(err.response.data.error[key], '', { timeOut: 0 });
          });
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingBookButton = false;
          this.buttonDisabled = false;
        });
    },
    setOfferError(err) {
      this.errors.record(err.response.data.error);
    },
    sendJobRescheduleEmail() {
      axios.post(`/jobs/${this.$route.params.id}/offers/send`).then(() => {
        toastr.success('Reschedule email successfully sent to the customer');
        this.$emit('save');
      });
    },
    callGetOffers() {
      this.changed = true;
      setTimeout(() => {
        if (this.$refs.offerRef) {
          this.$refs.offerRef.getOffers(this.job);
        }
      }, 0);
      this.errors.clear();
      if (this.$refs.offerRef) {
        this.$refs.offerRef.clearErrors();
      }
    },
    closedDatePickr() {
      const vm = this;
      async function f() {
        const promise = new Promise(resolve => {
          vm.$nextTick(() => resolve(vm.$set(vm.job, 'move_date', vm.job.move_date_new)));
        });
        if (await promise) {
          if (vm.job.move_date_new !== vm.job.move_date) {
            vm.updateOffers();
          }
        }
      }

      f();
    },
    updateOffers() {
      this.callGetOffers();
      this.$emit('editedField');
    },
  },
};
</script>
<style lang="scss" scoped>
.rates {
  line-height: 2;
}
.rates-icon {
  color: #3db152;
}
.fa-home {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobRates.vue